import styled from 'styled-components';
import { Format } from '../../utils/styles-constants';
import UserAgentUtils from '../../utils/userAgent';
import { BottomBarHeight } from '../../components/Page/styles';

const ListPageWrapper = styled('div')`
	display: flex;
	flex-wrap: nowrap;
	flex-direction: column;
	height: 100%;

	@media ${Format.SmartphoneLandscape} and (min-aspect-ratio: 2/1) {
		padding: ${UserAgentUtils.isIOS() ? '0 20px' : 0};
	}
`;

const DriveItemListActionButtons = styled('div')`
	display: flex;
	flex-wrap: nowrap;
	justify-content: flex-end;
	align-items: center;

	& > * > button > svg, & > * > svg {
		fill: ${props => props.theme.primary.iconsColor};
	}
`;

const NoItemsContainer = styled('div')`
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: ${BottomBarHeight};
`;

export { ListPageWrapper, DriveItemListActionButtons, NoItemsContainer };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/styles.ts